module.exports = __webpack_public_path__ + "static/kwts-7128e248a05a7b41f81cc79a08dd7451.jpg";